import * as React from "react";
import { SharedDocumentsComponent } from './SharedDocumentsComponent';

export const EventsVisits = () => {
    return <SharedDocumentsComponent permissionId="19" path="Eventos e Visitas" />
}